import { Component, OnInit ,Input} from '@angular/core';
import { ConstantsService } from '../../services/constants.service';
import { OmsServiceService } from '../../services/oms-service.service';
import { FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-order-reject-modal',
  templateUrl: './order-reject-modal.component.html',
  styleUrls: ['./order-reject-modal.component.scss']
})
export class OrderRejectModalComponent implements OnInit {

  orderRejectForm: FormGroup;

  @Input() order_id;
  @Input() channel_code;
  msg:string ="";

  isButtonEnable :Boolean =true;
  isSuccessMsg :Boolean =false;
  isFailureMsg :Boolean =false;
  
  constructor(

    private constantsService :ConstantsService,
    private omsService:OmsServiceService,
    public modal: NgbActiveModal,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private toastr: ToastrService
  ) { 
    this.orderRejectForm = new FormGroup({
       
      
      
      reason: new FormControl()
    });

  }

   listOfReasons :string[];
  ngOnInit(): void {
   this.isButtonEnable =true;
    //this.listOfReasons.push("onPrice/Product");
   // this.listOfReasons.push("Service related");

    this.listOfReasons =["onPrice/Product","Service related","Order related"];
  }


  orderReject(formData) {

    if(formData.controls.reason.value != null && formData.controls.reason.value !=undefined && formData.controls.reason.value!="")
    {
      let orderRejectRequest = {};
      orderRejectRequest["order_id"] = this.order_id;
      orderRejectRequest["actionByName"] = window.localStorage.getItem('actionByName');
      orderRejectRequest["actionById"] = window.localStorage.getItem('actionById');
      orderRejectRequest["source"] = "1";
      orderRejectRequest["status"] = 9;
      orderRejectRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
     //orderRejectRequest["channelCode"] =this.channel_code;
      orderRejectRequest["reason"] = formData.controls.reason.value;
      orderRejectRequest["action"] = 'OMS/api/operation.php/v1/order/change/status';
      orderRejectRequest["type"] = 'post';
      this.omsService.orderReject(orderRejectRequest).subscribe(
        (res) => {
          //console.log(res["message"]);
         // alert(res["message"]);
          this.msg =res["message"];
          this.isButtonEnable =false;
         // alert(res["message"]);
         // this.modal.close();
         // this._router.navigate(['/orders'], { queryParams: { session: localStorage.getItem("sessionId") } });
        }
      )
    }else{
        //  alert("please select reason");
        this.toastr.error("please select reason");
    }
    

  }

  close()
  {
    this.modal.close();
  }
  modelClose()
  {

    this.modal.close();
    this._router.navigate(['/orders']);
  }
}
